export function resolveShopId(item) {
  const raw = item?.shop_id ?? item?.shop;
  if (raw == null || raw === '') {
    return null;
  }
  const value = Number(raw);
  return Number.isFinite(value) && value > 0 ? value : null;
}

export function resolveShopLogoUrl(item, imageBase) {
  const raw = item?.shop_logo_url || item?.brand_logo;
  if (!raw) {
    return null;
  }
  return raw.startsWith('http') ? raw : `${imageBase}${raw}`;
}
